/*
 * @Description:
 * @Date: 2022-09-16 16:58:10
 */
export const WHITE_LIST: Array<string | symbol> = [
  '/main/enterprise-real/enterprise-real-redirect'
];
export const TOKEN_BLACK_LIST: Array<string | symbol> = [];
